// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { fontSize } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'

const Desc = styled.p`
  font-size: ${fontSize.small_2}px;
  color: ${Colors.gray9};
  line-height: 1.5;
  ${mediaMin.phone`
    font-size: ${fontSize.small}px;
  `};
`

export type PropTypes = {
  children: any,
}

export default (props: PropTypes) => <Desc>{props.children}</Desc>



// WEBPACK FOOTER //
// ./src/components/atoms/Description/index.jsx